import ky from "ky";
import { SERVER_ROOT } from "./constants";

export const apiClient = ky.extend({
  prefixUrl: `${SERVER_ROOT}/`,
  timeout: 15000,
});
